'use client'
import { getDynamicLink } from '@/lib/util/get-router'
import dayjs from 'dayjs'
import { useRouter } from 'next/navigation'
import React from 'react'

export default function BlogTextCard({ item, }: { item: any }) {
  const router = useRouter()
  return (
    <div
      onClick={() =>
        router.push(
          `${getDynamicLink()}/${item.id}?title=${item.cate.title}`
        )
      } className="group cursor-pointer flex flex-col mb-1.5 py-2 px-4 hover:shadow-[0_0_10px_0_rgba(0,0,0,0.2)]">
      <h3 className="text-gray-800 text-[15px] group-hover:text-main transition-colors truncate">
        {item.title}
      </h3>
      <p className="text-gray-400 text-sm">{dayjs(+item.created_at * 1000).format(
        'YYYY-MM-DD HH:mm:ss'
      )}</p>
    </div>

  )
}
